import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { IconArrowDownCircle } from '@tabler/icons-react';

const Realtimerate = () => {
  const [allRates, setAllRates] = useState({});

  const getRate = () => {
    axios({
      method:"GET",
      url:`${process.env.REACT_APP_BASE_URL}/setting/rate`
    }).then(res => {
      setAllRates(res.data.setting);
    }).catch(() => {})
  }

  useEffect(() => {
    getRate();
  }, []);

  return (
    <>
      <section className="current-rates">
        <Container>
          <Row>
            <Col md={12}>
              <div className="head-title">
                <div className="sup">Rates</div>
                <h2>Today's <span className='text-gradient'>Exchange Rates</span></h2>
                <div className="sub">* Updated daily. For the most accurate and real-time rates, please contact us.</div>
              </div>
            </Col>
          </Row>
          <Row className='justify-content-center'>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/CAD.png" alt="" />
                    <span>CAD</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/NGN.png" alt="" />
                    <span>NGN</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.cad?.rates?.ngn?.rate)) ? parseFloat(allRates?.cad?.rates?.ngn?.rate) > 0.01 ? parseFloat(allRates?.cad?.rates?.ngn?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.cad?.rates?.ngn?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/NGN.png" alt="" />
                    <span>NGN</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/USD.png" alt="" />
                    <span>USD</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.ngn?.rates?.usd?.rate)) ? parseFloat(allRates?.ngn?.rates?.usd?.rate) > 0.01 ? parseFloat(allRates?.ngn?.rates?.usd?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.ngn?.rates?.usd?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/NGN.png" alt="" />
                    <span>NGN</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/CNY.png" alt="" />
                    <span>CNY</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.ngn?.rates?.cny?.rate)) ? parseFloat(allRates?.ngn?.rates?.cny?.rate) > 0.01 ? parseFloat(allRates?.ngn?.rates?.cny?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.ngn?.rates?.cny?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/CAD.png" alt="" />
                    <span>CAD</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/USDT.png" alt="" />
                    <span>USDT</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.cad?.rates?.usdt?.rate)) ? parseFloat(allRates?.cad?.rates?.usdt?.rate) > 0.01 ? parseFloat(allRates?.cad?.rates?.usdt?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.cad?.rates?.usdt?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/USDT.png" alt="" />
                    <span>USDT</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/NGN.png" alt="" />
                    <span>NGN</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.usdt?.rates?.ngn?.rate)) ? parseFloat(allRates?.usdt?.rates?.ngn?.rate) > 0.01 ? parseFloat(allRates?.usdt?.rates?.ngn?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.usdt?.rates?.ngn?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                <div className="flag">
                    <img src="./Images/NGN.png" alt="" />
                    <span>NGN</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/EUR.png" alt="" />
                    <span>EUR</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.ngn?.rates?.eur?.rate)) ? parseFloat(allRates?.ngn?.rates?.eur?.rate) > 0.01 ? parseFloat(allRates?.ngn?.rates?.eur?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.ngn?.rates?.eur?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/NGN.png" alt="" />
                    <span>NGN</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/GBP.png" alt="" />
                    <span>GBP</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.ngn?.rates?.gbp?.rate)) ? parseFloat(allRates?.ngn?.rates?.gbp?.rate) > 0.01 ? parseFloat(allRates?.ngn?.rates?.gbp?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.ngn?.rates?.gbp?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/NGN.png" alt="" />
                    <span>NGN</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/MYR.png" alt="" />
                    <span>MYR</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.ngn?.rates?.myr?.rate)) ? parseFloat(allRates?.ngn?.rates?.myr?.rate) > 0.01 ? parseFloat(allRates?.ngn?.rates?.myr?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.ngn?.rates?.myr?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/CAD.png" alt="" />
                    <span>CAD</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/CNY.png" alt="" />
                    <span>CNY</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.cad?.rates?.cny?.rate)) ? parseFloat(allRates?.cad?.rates?.cny?.rate) > 0.01 ? parseFloat(allRates?.cad?.rates?.cny?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.cad?.rates?.cny?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/USDT.png" alt="" />
                    <span>USDT</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/CNY.png" alt="" />
                    <span>CNY</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.usdt?.rates?.cny?.rate)) ? parseFloat(allRates?.usdt?.rates?.cny?.rate) > 0.01 ? parseFloat(allRates?.usdt?.rates?.cny?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.usdt?.rates?.cny?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/CAD.png" alt="" />
                    <span>CAD</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/USD.png" alt="" />
                    <span>USD</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.cad?.rates?.usd?.rate)) ? parseFloat(allRates?.cad?.rates?.usd?.rate) > 0.01 ? parseFloat(allRates?.cad?.rates?.usd?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.cad?.rates?.usd?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
            <Col lg={3} sm={6} className='mb-4'>
              <div className="box">
                <div className="currency">
                  <div className="flag">
                    <img src="./Images/USD.png" alt="" />
                    <span>USD</span>
                  </div>
                  <div className="flag">
                    <img src="./Images/CNY.png" alt="" />
                    <span>CNY</span>
                  </div>
                </div>
                <div className="arrow">
                  <IconArrowDownCircle size={40} stroke={1} />
                </div>
                <div className="cont">
                  <strong>{!isNaN(parseFloat(allRates?.usd?.rates?.cny?.rate)) ? parseFloat(allRates?.usd?.rates?.cny?.rate) > 0.01 ? parseFloat(allRates?.usd?.rates?.cny?.rate).toLocaleString(undefined, { maximumFractionDigits:2, minimumFractionDigits:2 }) : parseFloat(allRates?.usd?.rates?.cny?.rate) : "0.00"}</strong>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  )
}

export default Realtimerate